import { FC, ReactNode } from 'react';

import { GET_STARTED_LINK } from './links.constants';
import { PATH_ADMIN, PATH_FAQ, PATH_INDEX } from './routes.constants';

type HeaderMenuItem = {
  title: string;
  href: string;
  isDisable: boolean;
  isNewTab?: boolean;
  icon?: ReactNode;
  submenu?: FC<{ onClose: () => void }> | undefined;
};

export const HEADER_ROUTES: HeaderMenuItem[] = [
  {
    title: 'Bonds',
    href: PATH_INDEX,
    isDisable: false,
  },
  {
    title: 'FAQ',
    href: PATH_FAQ,
    isDisable: false,
  },
  {
    title: 'Admin',
    href: PATH_ADMIN,
    isDisable: false,
  },
];

export const ROUTES_MOB: HeaderMenuItem[] = [
  {
    title: 'Bonds',
    href: PATH_INDEX,
    isDisable: false,
  },
  {
    title: 'FAQ',
    href: PATH_FAQ,
    isDisable: false,
  },
  {
    title: 'Get Started',
    href: GET_STARTED_LINK,
    isDisable: false,
    isNewTab: true,
  },
];
